import { render, staticRenderFns } from "./FloatingHeader.vue?vue&type=template&id=6dd0c156&scoped=true"
import script from "./FloatingHeader.vue?vue&type=script&lang=js"
export * from "./FloatingHeader.vue?vue&type=script&lang=js"
import style0 from "./FloatingHeader.vue?vue&type=style&index=0&id=6dd0c156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0c156",
  null
  
)

export default component.exports